import { render, staticRenderFns } from "./DodSmsList.vue?vue&type=template&id=3ba3948d&scoped=true&"
import script from "./DodSmsList.vue?vue&type=script&lang=js&"
export * from "./DodSmsList.vue?vue&type=script&lang=js&"
import style0 from "./DodSmsList.vue?vue&type=style&index=0&id=3ba3948d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba3948d",
  null
  
)

export default component.exports